var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1546 1H6.84537C3.25161 1 1 3.54364 1 7.14336V16.8566C1 20.4564 3.24208 23 6.84537 23H17.1534C20.7579 23 23 20.4564 23 16.8566V7.14336C23 3.54364 20.7579 1 17.1546 1Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4796 8.1945C10.4796 9.4091 9.49385 10.3949 8.27924 10.3949C7.06583 10.3949 6.08008 9.4091 6.08008 8.1945C6.08008 6.97989 7.06583 5.99414 8.27924 5.99414C9.49385 5.99414 10.4796 6.97989 10.4796 8.1945Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.999 15.5435C21.8142 14.5124 20.7831 13.2716 19.4243 12.4527C18.0631 11.6338 16.6005 12.1392 15.6565 13.361C14.7446 14.5422 14.1749 16.1311 12.7982 16.8761C11.102 17.7951 10.1055 16.3135 8.69067 15.7199C7.11133 15.0583 5.91222 16.2479 4.98964 17.391C4.06587 18.5353 3.13018 19.6676 2.19092 20.8",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3a387765ee612982cebe4fe48519cc3c.svg";
export { ForwardRef as ReactComponent };